import { useMemo } from 'react';
import { useBaseOwnerId } from '@rhino-project/core/hooks';
import type { RhinoFilter } from '@rhino-project/core';
import { ModelFilterReferenceBase } from '@rhino-project/ui-heroui';

// Users have no ownership chain to organization (they relate through
// users_roles), so Rhino's owner-reference filter can't scope the reporter
// dropdown to the current org — without this it lists users from every org
// the viewer belongs to. Scope it through the users_roles association instead.
export const ReporterModelFilter = (props: { path: string }) => {
  const baseOwnerId = useBaseOwnerId();
  const filter = useMemo(() => {
    if (!Number.isFinite(baseOwnerId)) return undefined;

    // Annotated here rather than on the memo: a literal returned straight from
    // a useMemo callback is not checked against its declared type.
    const scoped: RhinoFilter<'user'> = {
      users_roles: { organization: baseOwnerId }
    };
    return scoped;
  }, [baseOwnerId]);

  return <ModelFilterReferenceBase<'user'> filter={filter} {...props} />;
};
